module.exports = __webpack_public_path__ + "img/jl-15.383f8a6d.png";